import env from "../env"

export default function(name, value = true) {
  return typeof env[name] !== "undefined" && env[name] === value
}



// WEBPACK FOOTER //
// ./src/utils/checkEnv.js